// Renders a full contract (Order Confirmation HTML) in an isolated, zoomable iframe.
//
// The contract is laid out at a fixed document width (DOC_WIDTH) inside the iframe's own
// viewport. Specifying `width=DOC_WIDTH` makes the browser scale the document to fit the
// iframe's actual width (so no word-wrap/overlap), and `user-scalable=yes` lets the reader
// pinch-zoom in up to 5x and scroll around. `text-size-adjust:100%` disables mobile
// font-boosting, which was inflating some paragraphs and not others (the "tiny then huge"
// inconsistency). The iframe has a fixed visible height and scrolls internally.
const DOC_WIDTH = 820

const OVERRIDE =
  '<meta name="viewport" content="width=' + DOC_WIDTH + ', user-scalable=yes, maximum-scale=5, minimum-scale=0.2"/>' +
  '<style>' +
  'html{-webkit-text-size-adjust:100%;text-size-adjust:100%;}' +
  'body{margin:0!important;padding:20px!important;background:#fff!important;' +
  '-webkit-text-size-adjust:100%;text-size-adjust:100%;font-size:14px;line-height:1.55;}' +
  'img{max-width:100%;}' +
  'table{max-width:100%;}' +
  '@media print{@page{size:A4;margin:12mm;}html,body{padding:0!important;}img[alt="Silux Mobile"]{height:64px!important;}}' +
  '</style>'

export function ContractViewer({ html }: { html: string | null | undefined }) {
  const doc = html || ''
  const srcDoc = doc.includes('</head>') ? doc.replace('</head>', OVERRIDE + '</head>') : OVERRIDE + doc
  return (
    <div>
      <p className="mb-2 text-xs text-gray-500 flex items-center gap-1">
        <span aria-hidden>🔍</span>
        Pinch to zoom in, or scroll within the box to read the full contract.
      </p>
      <div className="border border-gray-300 rounded-md bg-white overflow-hidden">
        <iframe
          title="Contract"
          sandbox="allow-same-origin"
          style={{
            width: '100%',
            height: '70vh',
            minHeight: '420px',
            border: 'none',
            display: 'block',
            touchAction: 'pan-x pan-y pinch-zoom' as any,
          }}
          srcDoc={srcDoc}
        />
      </div>
    </div>
  )
}

export default ContractViewer
